import type { AccountTrendMetric } from '../types/accountTrend';
import { formatMoneyAmount } from './formatMoney';

export function formatAccountMetricValue(
  value: number,
  metric: AccountTrendMetric,
  currencyCode: string
): string {
  if (metric === 'hours') {
    return `${value.toFixed(2)} h`;
  }
  return formatMoneyAmount(value, currencyCode);
}
